import { render, staticRenderFns } from "./SysNotiMng.vue?vue&type=template&id=5e8062b5&scoped=true&"
import script from "./SysNotiMng.vue?vue&type=script&lang=js&"
export * from "./SysNotiMng.vue?vue&type=script&lang=js&"
import style0 from "./SysNotiMng.vue?vue&type=style&index=0&id=5e8062b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8062b5",
  null
  
)

export default component.exports